import { t } from '@lingui/core/macro';
import { Stack } from '@mui/material';
import { type LinkProps, useCanGoBack, useRouter } from '@tanstack/react-router';
import { ArrowLeftIcon } from 'components/icons/ArrowLeftIcon';
import type { FC, MouseEventHandler } from 'react';
import { StyledNavLink } from './styles';

type Props = {
  goBackUrl?: LinkProps['to'];
  color?: string;
};

export const GoBackLink: FC<Props> = ({ goBackUrl, color }) => {
  const router = useRouter();
  const canGoBack = useCanGoBack();

  const handleNavigation: MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault();
    if (canGoBack) {
      router.history.back();
    }
  };

  return (
    <StyledNavLink onClick={handleNavigation} to={goBackUrl || '/'}>
      <Stack direction="row" alignItems="center" color={color}>
        <ArrowLeftIcon fontSize="small" /> {t`Retour`}
      </Stack>
    </StyledNavLink>
  );
};
